// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__1JKjC","headerContent":"header_headerContent__V7DeG","logoImg":"header_logoImg__om2vR","btnLink":"header_btnLink__1WPCT"};